import { OneTrustProvider } from '@grandvisionhq/cookie-consent'
import { withConsent as withConsentFactory } from '@grandvisionhq/next'

export const withConsent = withConsentFactory(OneTrustProvider)
